/* eslint-disable */
// @ts-nocheck
import { z } from 'zod'
import { VehiclesWithFeatureInput, VehicleSearchFilter, Vehicle, VehicleSearchFilters, VehicleSafetyFields, VehicleSafetyFeature, VehicleEcoData, VehicleCostData, VehicleComfortFeature, VehicleSearchResult, VehicleOverrideFields, VehicleDerivedFields, SafetyFeature, MakeModelItem, MakeModel, GetYearsInput, GetVehiclesInput, GetVehicleInput, ExcludeFilter, VehicleSearchInput, AncapTestResult, GradingLabel, AncapReportType, AncapTestRecord } from './graphql'

type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K], any, T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export const GradingLabelSchema = z.nativeEnum(GradingLabel);

export const AncapReportTypeSchema = z.nativeEnum(AncapReportType);

export const VehiclesWithFeatureInputSchema: z.ZodObject<Properties<VehiclesWithFeatureInput>> = z.object({
    equipcode: z.string()
});

export const VehicleSearchFilterSchema: z.ZodObject<Properties<VehicleSearchFilter>> = z.object({
    __typename: z.literal('VehicleSearchFilter').optional(),
    label: z.string(),
    value: z.string()
});

export const VehicleSchema: z.ZodObject<Properties<Vehicle>> = z.object({
    __typename: z.literal('Vehicle').optional(),
    description: z.string(),
    makedescription: z.string(),
    modeldescription: z.string(),
    vehicleid: z.string(),
    year: z.number()
});

export const VehicleSearchFiltersSchema: z.ZodObject<Properties<VehicleSearchFilters>> = z.object({
    __typename: z.literal('VehicleSearchFilters').optional(),
    bodyTypes: z.array(VehicleSearchFilterSchema),
    makes: z.array(VehicleSearchFilterSchema),
    recommendedSafetyFeatures: z.array(VehicleSearchFilterSchema)
});

export const VehicleSafetyFieldsSchema: z.ZodObject<Properties<VehicleSafetyFields>> = z.object({
    __typename: z.literal('VehicleSafetyFields').optional(),
    activeratingprovider: z.string().nullish(),
    ancaptestyear: z.number().nullish(),
    safetyFeatures: z.array(z.string()).nullish(),
    stars: z.number().nullish(),
    vehicleid: z.string()
});

export const VehicleSafetyFeatureSchema: z.ZodObject<Properties<VehicleSafetyFeature>> = z.object({
    __typename: z.literal('VehicleSafetyFeature').optional(),
    isprimaryfeature: z.boolean().nullish(),
    isrecommended: z.boolean().nullish(),
    isstandard: z.boolean().nullish(),
    safetyfeaturecode: z.string().nullish(),
    safetyfeaturename: z.string().nullish()
});

export const VehicleEcoDataSchema: z.ZodObject<Properties<VehicleEcoData>> = z.object({
    __typename: z.literal('VehicleEcoData').optional(),
    airpollutionrating: z.number().nullish(),
    co2combined: z.number().nullish(),
    co2extraurban: z.number().nullish(),
    co2urban: z.number().nullish(),
    emissionstandard: z.string().nullish(),
    energyconsumption: z.number().nullish(),
    fuelcombined: z.number().nullish(),
    fuelextraurban: z.number().nullish(),
    fuelurban: z.number().nullish(),
    greenhouserating: z.number().nullish(),
    kmrangeelectricwltp: z.number().nullish(),
    powerplanttype: z.string().nullish(),
    vehicleid: z.string()
});

export const VehicleCostDataSchema: z.ZodObject<Properties<VehicleCostData>> = z.object({
    __typename: z.literal('VehicleCostData').optional(),
    estimatedrunningcost: z.number().nullish(),
    fuelconsumption: z.string().nullish(),
    fueltype: z.string().nullish(),
    vehicleid: z.string()
});

export const VehicleComfortFeatureSchema: z.ZodObject<Properties<VehicleComfortFeature>> = z.object({
    __typename: z.literal('VehicleComfortFeature').optional(),
    comfortfeaturecode: z.string().nullish(),
    comfortfeaturename: z.string().nullish(),
    vehicleid: z.string()
});

export const VehicleSearchResultSchema: z.ZodObject<Properties<VehicleSearchResult>> = z.object({
    __typename: z.literal('VehicleSearchResult').optional(),
    activeratingprovider: z.string().nullish(),
    ancaptestyear: z.number().nullish(),
    badgedescription: z.string().nullish(),
    bodytype: z.string().nullish(),
    costRating: z.string().nullish(),
    description: z.string(),
    ecoRating: z.string().nullish(),
    enginedisplacement: z.string().nullish(),
    featuresRating: z.string().nullish(),
    fueltype: z.string().nullish(),
    isbaseoption: z.boolean().nullish(),
    isblacklisted: z.boolean().nullish(),
    isrecommendable: z.boolean().nullish(),
    lifestyle: z.array(z.string()).nullish(),
    makedescription: z.string(),
    makeid: z.string(),
    makeslug: z.string().nullish(),
    maxprice: z.number().nullish(),
    minprice: z.number().nullish(),
    modeldescription: z.string(),
    modelid: z.string(),
    modelslug: z.string().nullish(),
    month: z.string(),
    photoId: z.string().nullish(),
    pplatestatus: z.string().nullish(),
    safecarforfamilies: z.boolean().nullish(),
    safetyRating: z.string().nullish(),
    safetyfeatures: z.array(z.string()).nullish(),
    sequencenumber: z.number().nullish(),
    series: z.string().nullish(),
    stars: z.number().nullish(),
    transmission: z.string().nullish(),
    ucsrAggressivity: z.number().nullish(),
    ucsrDriver: z.number().nullish(),
    ucsrPrimarySafety: z.number().nullish(),
    vehicleid: z.string(),
    vfactssegment: z.string().nullish(),
    year: z.number()
});

export const VehicleOverrideFieldsSchema: z.ZodObject<Properties<VehicleOverrideFields>> = z.object({
    __typename: z.literal('VehicleOverrideFields').optional(),
    imageoverride: z.string().nullish(),
    isblacklisted: z.boolean().nullish(),
    ratingprovideroverride: z.string().nullish(),
    vehicleid: z.string()
});

export const VehicleDerivedFieldsSchema: z.ZodObject<Properties<VehicleDerivedFields>> = z.object({
    __typename: z.literal('VehicleDerivedFields').optional(),
    derivedbodycode: z.string().nullish(),
    derivedbodydescription: z.string().nullish(),
    lifestyle: z.string().nullish(),
    ratingprovider: z.string().nullish(),
    vehicleid: z.string()
});

export const SafetyFeatureSchema: z.ZodObject<Properties<SafetyFeature>> = z.object({
    __typename: z.literal('SafetyFeature').optional(),
    isrecommended: z.boolean(),
    safetyfeaturecode: z.string(),
    safetyfeaturename: z.string()
});

export const MakeModelItemSchema: z.ZodObject<Properties<MakeModelItem>> = z.object({
    __typename: z.literal('MakeModelItem').optional(),
    description: z.string(),
    id: z.string()
});

export const MakeModelSchema: z.ZodObject<Properties<MakeModel>> = z.object({
    __typename: z.literal('MakeModel').optional(),
    make: MakeModelItemSchema,
    models: z.array(MakeModelItemSchema)
});

export const GetYearsInputSchema: z.ZodObject<Properties<GetYearsInput>> = z.object({
    make: z.string(),
    model: z.string()
});

export const GetVehiclesInputSchema: z.ZodObject<Properties<GetVehiclesInput>> = z.object({
    vehicleids: z.array(z.string())
});

export const GetVehicleInputSchema: z.ZodObject<Properties<GetVehicleInput>> = z.object({
    makeid: z.string().nullish(),
    modelid: z.string().nullish(),
    vehicleid: z.string().nullish(),
    year: z.number().nullish()
});

export const ExcludeFilterSchema: z.ZodObject<Properties<ExcludeFilter>> = z.object({
    makedescription: z.string().nullish(),
    modeldescription: z.string().nullish(),
    year: z.number().nullish()
});

export const VehicleSearchInputSchema: z.ZodObject<Properties<VehicleSearchInput>> = z.object({
    bodyTypes: z.array(z.string()).nullish(),
    excludeFilter: ExcludeFilterSchema.nullish(),
    excludeVehicles: z.array(z.string()).nullish(),
    includeAllVariants: z.boolean().nullish(),
    includeNonRecommendable: z.boolean().nullish(),
    lifestyle: z.string().nullish(),
    limit: z.number().nullish(),
    make: z.array(z.string()).nullish(),
    makeSlug: z.array(z.string()).nullish(),
    maxAncapYear: z.number().nullish(),
    maxPrice: z.number().nullish(),
    maxSafetyFeaturesCount: z.number().nullish(),
    maxYear: z.number().nullish(),
    minAncapYear: z.number().nullish(),
    minPrice: z.number().nullish(),
    minSafetyFeaturesCount: z.number().nullish(),
    minYear: z.number().nullish(),
    model: z.array(z.string()).nullish(),
    modelSlug: z.array(z.string()).nullish(),
    offset: z.number().nullish(),
    pPlaterApproved: z.boolean().nullish(),
    powerTypes: z.array(z.string()).nullish(),
    price: z.number().nullish(),
    redbookSegment: z.array(z.string()).nullish(),
    safeCarsForFamilies: z.boolean().nullish(),
    safetyFeatures: z.array(z.string()).nullish(),
    starRating: z.array(z.number()).nullish()
});

export const AncapTestResultSchema: z.ZodObject<Properties<AncapTestResult>> = z.object({
    __typename: z.literal('AncapTestResult').optional(),
    isassessed: z.boolean().nullish(),
    maxvalue: z.string().nullish(),
    name: z.string().nullish(),
    type: z.string().nullish(),
    units: z.string().nullish(),
    value: z.string().nullish()
});

export const AncapTestRecordSchema: z.ZodObject<Properties<AncapTestRecord>> = z.object({
    __typename: z.literal('AncapTestRecord').optional(),
    ancapUrl: z.string(),
    gradingLabel: GradingLabelSchema.nullish(),
    gradingYear: z.string().nullish(),
    isAncapValid: z.boolean().nullish(),
    protocolVersion: z.string().nullish(),
    rating: z.number().nullish(),
    ratingYear: z.string().nullish(),
    reportType: AncapReportTypeSchema,
    technicalReportUrl: z.string().nullish(),
    testResults: z.array(AncapTestResultSchema)
});
